<div class="progress" [ngClass]="{'progress-striped': striped, 'progress-animated': animated}">
  <div class="progress-bar" 
       [ngClass]="bgClass"
       [style.width.%]="value"
       [style.height]="height"
       role="progressbar"
       [attr.aria-valuenow]="value"
       aria-valuemin="0"
       aria-valuemax="100"
       [attr.aria-label]="value + '% Complete'">
    <span class="visually-hidden">{{ value }}% Complete</span>
  </div>
</div> <!-- b5 e göre düzenlendi-->
